import type { default as DB, ECPMItem } from '../db/DB';
import { duration } from '../utils/Utils';

const CACHE_EXPIRES_IN_MS = duration({ minutes: 10 });

export class ServerReplicantECPM {
    private cache: ECPMItem | null = null;

    constructor(
        private opts: {
            dateNow: () => number;
            db: DB<any>;
        },
    ) {}

    /**
     * @param countryCode 2 letter ISO-3166-1 country code.
     * @returns eCPM values grouped by ad placement ID.
     */
    async getECPM(countryCode: string): Promise<{ [placementId: string]: number }> {
        const refreshCache = !this.cache || this.cache.timestamp + CACHE_EXPIRES_IN_MS < this.opts.dateNow();

        if (refreshCache) {
            try {
                // The DB value is written by a scheduled Lambda - see src/ecpm/README.md
                const newEcpm = await this.opts.db.ecpm.get();
                if (newEcpm && (!this.cache || newEcpm.timestamp > this.cache.timestamp)) {
                    this.cache = newEcpm;
                }
            } catch {
                // Ignore error - DB error is reported in `this.opts.db`
            }
        }

        return this.cache?.values?.[countryCode] ?? {};
    }
}
